export const NETWORK = {
    MAINNET: 'f',
    TESTNET: 't'
};

export const NETWORK_PATH = {
    MAINNET_PATH: '461',
    TESTNET_PATH: '1'
}
export const getCoinTypeFromPath = function getCoinTypeFromPath(path) {
    return path.split('/')[2].slice(0, -1);
}
export const ProtocolIndicator = {
    ID: 0,
    SECP256K1: 1,
    ACTOR: 2,
    BLS: 3,
    DELEGATED: 4,
};
export const MaxSubaddressBytes = 54;
